export default __webpack_public_path__ + "static/media/tour-e-agency-desktop-three.8ed01b97.png";